import { Box, Typography } from '@mui/material';

interface MetricCardProps {
    label: string;
    value: string | number;
    subtext?: string;
    isHighlighted?: boolean;
}

export const MetricCard = ({ label, value, subtext, isHighlighted = false }: MetricCardProps) => {
    return (
        <Box sx={{
            padding: 2,
            background: isHighlighted 
                ? 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)'
                : 'white',
            border: isHighlighted 
                ? '1px solid #86efac'
                : '1px solid #e2e8f0',
            borderRadius: 2,
            transition: 'all 0.2s ease',
            '&:hover': {
                borderColor: isHighlighted ? '#4ade80' : '#cbd5e1',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
            }
        }}>
            <Typography sx={{ fontSize: '0.7rem', color: '#64748b', fontWeight: 600, mb: 1 }}>
                {label}
            </Typography>
            <Typography sx={{ 
                fontSize: '1.5rem', 
                fontWeight: 700,
                color: isHighlighted ? '#059669' : '#1e293b',
                mb: subtext ? 0.5 : 0
            }}>
                {value}
            </Typography>
            {subtext && (
                <Typography sx={{ fontSize: '0.75rem', color: '#64748b' }}>
                    {subtext}
                </Typography>
            )}
        </Box>
    );
};
